import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSalesOrders(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('sales/sales-order', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSalesOrderStatusCounts() {
      return new Promise((resolve, reject) => {
        axios
          .get('sales/sales-order/status-counts')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSalesOrder(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`sales/sales-order/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addComment(ctx, { id, text }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/comment`, { text })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addAttachment(ctx, { id, file }) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('file', file)
        axios
          .post(`sales/sales-order/${id}/attachment`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeAttachment(ctx, { id, attachmentId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`sales/sales-order/${id}/attachment/${attachmentId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateAttachmentDescription(ctx, { id, attachmentId, description }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/attachment/${attachmentId}/description`, { description })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateRequiredInformation(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/required-information`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateServiceAgent(ctx, { id, agentId }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/service-agent`, { agentId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSalesAgent(ctx, { id, agentId }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/sales-agent`, { agentId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    requestResign(ctx, { id, attachmentId }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/attachment/${attachmentId}/request-resign`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePurchaserDetails(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/purchaser-details`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateIntendedUser(ctx, { id, userId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/intended-user/${userId}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateAuthorizedPerson(ctx, { id, userId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/authorized-person/${userId}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateInstallment(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/installment`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePromotions(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`sales/sales-order/${id}/promotions`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeIntendedUser(ctx, { id, userId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`sales/sales-order/${id}/intended-user/${userId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeAuthorizedPerson(ctx, { id, userId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`sales/sales-order/${id}/authorized-person/${userId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidSalesOrder(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/void`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    completeWorkflowStep(ctx, { id, note }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/workflow/complete`, { note })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendBackToAgent(ctx, { id, note }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/workflow/send-back`, { note })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    revertToStep(ctx, { id, toStep, note }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/workflow/revert`, { toStep, note })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    assignBackToDepartment(ctx, { id, toDepartment, note }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/workflow/assign-back`, { toDepartment, note })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    reassignBackToOwner(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`sales/sales-order/${id}/workflow/reassign-back-to-owner`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
